import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { YearlyBudgetRoutingModule } from './yearly-budget-routing.module';
import { YearlyBudgetComponent } from './yearly-budget.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DxDataGridModule, DxCheckBoxModule, DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'app/material.module';

@NgModule({
  declarations: [YearlyBudgetComponent],
  imports: [
    CommonModule,
    YearlyBudgetRoutingModule,
    NgxSpinnerModule,
    DxDataGridModule,
    I18nModule,
    FormsModule,
    MaterialModule
  ]
})
export class YearlyBudgetModule { }
